function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.7 283.7"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M35.4 0v283.5H248V92.1L141.7 0H35.4zm120.4 49.8L188.3 78h-32.5V49.8zM63.7 255.1V28.3h63.8v78h92.1v148.8H63.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.8 113.4s-35.3 42.4-35.2 73.4c.1 19.7 10.3 36.1 28.2 39.5v14.9H149v-14.9c17.9-3.4 28.5-19.8 28.4-39.5 0-31-35.5-73.4-35.6-73.4zm7.2 97.9V149c9 15.2 13.9 28.6 13.9 37.9 0 8.3-2.6 15.7-7.2 20.2-1.8 1.9-4.1 3.3-6.7 4.2zm-14.2 0c-3-1-5.7-2.9-7.7-5.4-3.8-4.6-6-11.4-6-19.2 0-9.3 4.8-22.6 13.7-37.8v62.4z"
})));